<fuse-loading-bar *ngIf="showLoadingBar()"></fuse-loading-bar>
<router-outlet></router-outlet>